import { DataGridCellRendererProps } from '@myosh/odin-components';
import React from 'react';

function CustomClickableCellComponent({
  dataGrid,
  handleCellClick,
}: {
  dataGrid: DataGridCellRendererProps;
  handleCellClick: (rowId: string, columnId: string) => void;
}) {
  return (
    <div className="block">
      <div
        onClick={() => {
          handleCellClick(dataGrid.rowData.firstField as string, String(dataGrid.column.id));
        }}
        className="truncate pl-2"
      >
        {String(dataGrid.rowData[`${dataGrid.column.id}` as keyof typeof dataGrid.rowData])}
      </div>
    </div>
  );
}

export default CustomClickableCellComponent;
